var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlaybutton = function SvgPlaybutton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Playbutton_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 106,
    r: 100,
    fill: "#D46A19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.546 147a3.59 3.59 0 0 1-2.508-1.013A3.414 3.414 0 0 1 80 143.542V67.458c0-.601.16-1.192.466-1.714a3.501 3.501 0 0 1 1.275-1.263 3.617 3.617 0 0 1 3.513-.053l70.911 38.042a3.516 3.516 0 0 1 1.342 1.27 3.394 3.394 0 0 1 0 3.519 3.509 3.509 0 0 1-1.342 1.27l-70.91 38.042a3.616 3.616 0 0 1-1.71.429Z",
    fill: "#F0EAE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Playbutton_svg__a",
    x: 0,
    y: 0,
    width: 220,
    height: 220,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4520_161835"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4520_161835",
    result: "shape"
  })))));
};

export default SvgPlaybutton;